import React from 'react';
import ClientPaymentItem from '../../../Domain/ClientPaymentItem';
import ClientPaymentService from '../../../Services/ClientPaymentService';
import ShowEntityData from '../../../Elements/ShowEntityData';

export default class ClientPaymentDetailsInfoTab extends React.Component {
  static defaultProps = {
    clientPaymentId: 0
  };

  constructor(props) {
    super(props);

    this.state = {
      clientPaymentId: props.clientPaymentId
    };
  }

  render() {
    return (
      <ShowEntityData
        itemId={this.state.clientPaymentId}
        type={ClientPaymentItem}
        serviceGetByIdFunction={ClientPaymentService.GetByPaymentId}
      />
    );
  }
}
